import { Selector, State, StateContext, createSelector } from '@ngxs/store';
import { Receiver } from '@ngxs-labs/emitter';
import { Injectable, Injector } from '@angular/core';
import { ENDPOINTS } from 'src/app/@config';
import { IdNamePair } from 'src/app/@models';
import { DropdownService } from 'src/app/@services';

@State<IdNamePair[]>({
  name: 'customerClusters',
  defaults: []
})
@Injectable()
export class CustomerClustersState {
  private static dropdownService: DropdownService

  static hasAny() {
    return createSelector([CustomerClustersState], (state: IdNamePair[]) => {
      return state?.length > 0;
    });
  }

  @Selector()
  static isEmpty(state: IdNamePair[]): boolean {
    return state.length === 0;
  }

  constructor(injector: Injector) {
    CustomerClustersState.dropdownService = injector.get(DropdownService);
  }

  @Receiver()
  static loadAll({ setState }: StateContext<IdNamePair[]>) {
    this.dropdownService.getIdNameList(ENDPOINTS.getCustomerClusterList()).subscribe((data: IdNamePair[]) => setState(data));
  }
}
